import { Link } from "react-router-dom";

import { trans } from "~/providers/lang";
import { getSmallPhoto, getFileName } from "~/utils/photo";
import ArrowRight from "../ArrowRight";

import "./style.less";

interface IGalleryEnter {
	link: string;
	items: Array<any>;
}

export default function GalleryEnter({
	link = "",
	items = [],
}: IGalleryEnter) {
	return <div className="gallery-enter-cont">
		<div className="row">
			<h2>
				{trans('common.gallery.preview')}
			</h2>
		</div>
		<div className="row gallery-list">
			{items.map(item => <div className="col-md-3" key={item.photo}>
				<Link to={`${link}?strana=1&fotka=${getFileName(item.photo)}`}>
					<div className="gallery-item">
						<div className="gallery-item-inner">
							<img src={getSmallPhoto(item)} />
						</div>
					</div>
				</Link>
			</div>)}
			<div className="col-md-3 gallery-enter">
				<div className="gallery-enter__inner">
					<Link to={link}>
						<span>
							{trans('common.gallery.enter')}
						</span>
						<ArrowRight className="arrow" />
					</Link>
				</div>
			</div>
		</div>
	</div>;
}
